import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

const LeafLine = ({ className }) => (
  <svg viewBox="0 0 200 260" fill="none" className={className} aria-hidden="true">
    <motion.path
      d="M100 250C100 170 100 110 100 20M100 20C40 50 20 120 100 190M100 20C160 50 180 120 100 190M100 80L60 60M100 110L52 92M100 140L58 128M100 80L140 60M100 110L148 92M100 140L142 128"
      stroke="#16803C"
      strokeWidth="1.6"
      strokeLinecap="round"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 2.6, delay: 0.6, ease: "easeInOut" }}
    />
  </svg>
);

const Sprig = ({ className }) => (
  <svg viewBox="0 0 160 220" fill="none" className={className} aria-hidden="true">
    <motion.path
      d="M80 215C80 150 70 90 40 20M74 160C50 150 30 128 26 98C52 104 70 124 74 160ZM64 110C82 96 92 72 90 44C68 58 60 84 64 110ZM52 70C34 62 24 44 26 24C44 32 54 50 52 70Z"
      stroke="#16803C"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      initial={{ pathLength: 0 }}
      animate={{ pathLength: 1 }}
      transition={{ duration: 2.8, delay: 0.9, ease: "easeInOut" }}
    />
  </svg>
);

export const HeroDecor = ({ mouse }) => {
  const reduce = useReducedMotion();
  const { scrollY } = useScroll();
  const yA = useTransform(scrollY, [0, 600], [0, reduce ? 0 : -120]);
  const yB = useTransform(scrollY, [0, 600], [0, reduce ? 0 : 90]);

  return (
    <div className="pointer-events-none absolute inset-0" aria-hidden="true">
      <div className="ag-grid absolute inset-0" />
      <div
        className="ag-glow absolute left-1/2 top-[45%] h-[520px] w-[520px] rounded-full sm:h-[760px] sm:w-[760px]"
        style={{
          background:
            "radial-gradient(circle, rgba(22,128,60,0.20) 0%, rgba(22,128,60,0.07) 38%, rgba(255,255,255,0) 68%)",
        }}
      />
      <motion.div style={{ y: yA, x: mouse.x }} className="absolute -left-6 top-24 sm:left-[6%] sm:top-[22%]">
        <div className="ag-float">
          <LeafLine className="h-36 w-28 opacity-40 sm:h-64 sm:w-48 sm:opacity-60" />
        </div>
      </motion.div>
      <motion.div style={{ y: yB, x: mouse.xInv }} className="absolute -right-4 bottom-16 sm:bottom-[12%] sm:right-[7%]">
        <div className="ag-float-slow">
          <Sprig className="h-32 w-24 opacity-40 sm:h-60 sm:w-44 sm:opacity-60" />
        </div>
      </motion.div>
      <motion.div
        style={{ y: yA, x: mouse.xInv }}
        className="ag-dots absolute right-[14%] top-[20%] hidden h-28 w-28 rounded-full opacity-70 md:block"
      />
      <motion.div
        style={{ y: yB, x: mouse.x }}
        className="ag-dots absolute bottom-[16%] left-[16%] hidden h-20 w-20 rounded-full opacity-70 md:block"
      />
    </div>
  );
};
